// CourseDetail.js
import React from 'react';
import { useParams } from 'react-router-dom';
import './CourseDetail.css';
import plusCourseLogoIcon from './pluscourse.jpg';
import pdeCourseLogoIcon from './pdecourse.jpg';
import hysysCourseLogoIcon from './hysyscourse.jpeg';
const courses = [
  {
    id: 'ProcessDesignEngieering',
    title: 'Process Design & Engineering (Dec 2025)',
    instructor: 'Synergyy',
    duration: 30,
    originalPrice: 11999,
    discountedPrice: 9999,
    bookedPercentage: 77,
    usersCount: 45,
    image: pdeCourseLogoIcon, // Image path or URL
    overview: 'Join this program to improve the skills needed for a chemical engineer to transform into a good process engineer.',
    syllabus: [
      'Introduction to Process Design',
      'P&ID Development',
      'Equipment Sizing and Specification',
      'Process Simulation',
      'Safety in Process Design',
    ],
    instructorBio: 'Synergyy is a team of experienced professionals with a strong background in process engineering and design.',
    reviews: [
      { user: 'Jinal Desai', comment: 'Helped me to crack Process Engineering Job ! Very informative.', rating: 5 },
      { user: 'Meghna Thakkar', comment: 'Learned a lot about process design.', rating: 4 },
    ],
    videoUrl: 'https://www.youtube.com/embed/owt1SiAeeAc', // URL to the course video preview
    materialIncludes: [
      'Documented notes',
      'Live lectures',
      'Recorded Sessions',
      'Weekly Test'
    ],
    requirements: [
      'Laptop/Mobile to access the live/recorded lectures.'
    ],
    audience: [
      'BE/ B Tech in Chemical, Petrochemical Engineering',
      'ME/ M Tech in Chemical Petrochemical Engineering',
      'Engineers working in Production and other fields',
      'Last year Students in Chemical, Petrochemical Engineering',
      'Diploma in Chemical, Petrochemical Engineering'
    ]
  },
  {
    id: 'ProcessSafety',
    title: 'Process Safety (Jan 2026)',
    instructor: 'Synergyy',
    duration: 24,
    originalPrice: 11999,
    discountedPrice: 9999,
    bookedPercentage: 21,
    usersCount: 12,
    image: hysysCourseLogoIcon, // Image path or URL
    overview: 'Join this program to improve the skills needed for a chemical engineer to transform into a good process engineer.',
    syllabus: [
      'Safety in Process Design',
    ],
    instructorBio: 'Synergyy is a team of experienced professionals with a strong background in process engineering and design.',
    reviews: [
      { user: 'Shrey Dave', comment: 'Great course! Very informative.', rating: 5 },
      { user: 'Mittal Shah', comment: 'Learned a lot about process design.', rating: 4 },
    ],
    videoUrl: 'https://www.youtube.com/embed/owt1SiAeeAc', // URL to the course video preview
    materialIncludes: [
      'Documented notes',
      'Live lectures',
      'Recorded Sessions',
      'Weekly Test'
    ],
    requirements: [
      'Laptop/Mobile to access the live/recorded lectures.'
    ],
    audience: [
      'BE/ B Tech in Chemical, Petrochemical Engineering',
      'ME/ M Tech in Chemical Petrochemical Engineering',
      'Engineers working in Production and other fields',
      'Last year Students in Chemical, Petrochemical Engineering',
      'Diploma in Chemical, Petrochemical Engineering'
    ]
  },
  {
    id: 'AspenPlus',
    title: 'Aspen Plus (Jan 2026)',
    instructor: 'Synergyy',
    duration: 24,
    originalPrice: 14999,	
    discountedPrice: 11999,
    bookedPercentage: 25,
    usersCount: 17,
    image: plusCourseLogoIcon, // Image path or URL
    overview: 'Join this program to improve the skills needed for a chemical engineer to transform into a good process engineer.',
    syllabus: [
      'Introduction to Process Design',
      'P&ID Development',
      'Equipment Sizing and Specification',
      'Process Simulation',
      'Safety in Process Design',
    ],
    instructorBio: 'Synergyy is a team of experienced professionals with a strong background in process engineering and design.',
    reviews: [
      { user: 'Nandini Mehta', comment: 'Great course!', rating: 5 },
      { user: 'Khevna Desai', comment: 'Learned a lot about process design.', rating: 4 },
    ],
    videoUrl: 'https://www.youtube.com/embed/owt1SiAeeAc', // URL to the course video preview
    materialIncludes: [
      'Documented notes',
      'Live lectures',
      'Recorded Sessions',
      'Weekly Test'
    ],
    requirements: [
      'Laptop/Mobile to access the live/recorded lectures.'
    ],
    audience: [
      'BE/ B Tech in Chemical, Petrochemical Engineering',
      'ME/ M Tech in Chemical Petrochemical Engineering',
      'Engineers working in Production and other fields',
      'Last year Students in Chemical, Petrochemical Engineering',
      'Diploma in Chemical, Petrochemical Engineering'
    ]
  },
  {
    id: 'AspenHysys',
    title: 'Aspen Hysys (Jan 2025)',
    instructor: 'Synergyy',
    duration: 38,
    originalPrice: 14999,
    discountedPrice: 11999,
    bookedPercentage: 42,
    usersCount: 14,
    image: hysysCourseLogoIcon, // Image path or URL
    overview: 'Join this program to improve the skills needed for a chemical engineer to transform into a good process engineer.',
    syllabus: [
      'Introduction to Process Design',
      'P&ID Development',
      'Equipment Sizing and Specification',
      'Process Simulation',
      'Safety in Process Design',
    ],
    instructorBio: 'Synergyy is a team of experienced professionals with a strong background in process engineering and design.',
    reviews: [
      { user: 'Hira Bhatt', comment: 'Great course! Very informative.', rating: 5 },
      { user: 'Jhanvi Nanavati', comment: 'Learned a lot about process design.', rating: 4 },
    ],
    videoUrl: 'https://www.youtube.com/embed/owt1SiAeeAc', // URL to the course video preview
    materialIncludes: [
      'Documented notes',
      'Live lectures',
      'Recorded Sessions',
      'Weekly Test'
    ],
    requirements: [
      'Laptop/Mobile to access the live/recorded lectures.'
    ],
    audience: [
      'BE/ B Tech in Chemical, Petrochemical Engineering',
      'ME/ M Tech in Chemical Petrochemical Engineering',
      'Engineers working in Production and other fields',
      'Last year Students in Chemical, Petrochemical Engineering',
      'Diploma in Chemical, Petrochemical Engineering'
    ]
  },
  // Add more courses as needed
];

const CourseDetail = () => {
  const { courseId } = useParams();
  const course = courses.find(course => course.id === courseId);

  if (!course) {
    return <div>Course not found</div>;
  }

  return (
    <div className="course-detail">
    <h1>{course.title}</h1>
    <img src={course.image} alt={course.title} />
    <p><strong>Instructor:</strong> {course.instructor}</p>
    <p><strong>Duration:</strong> {course.duration}h</p>
    <p><strong>Original Price:</strong> ₹{course.originalPrice}</p>
    <p><strong>Discounted Price:</strong> ₹{course.discountedPrice}</p>
    <p><strong>Enrolled:</strong> {course.usersCount} users</p>
    <p><strong>Booked:</strong> {course.bookedPercentage}%</p>

    <div className="course-video">
      <iframe
        width="560"
        height="315"
        src={course.videoUrl}
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        title="Course video"
      ></iframe>
    </div>

    <h2>About Course</h2>
    <p>{course.overview}</p>

    <h2>Course Syllabus</h2>
    <ul>
      {course.syllabus.map((item, index) => (
        <li key={index}>{item}</li>
      ))}
    </ul>

    <h2>Instructor Bio</h2>
    <p>{course.instructorBio}</p>

    <h2>Reviews</h2>
    <ul>
      {course.reviews.map((review, index) => (
        <li key={index}>
          <strong>{review.user}:</strong> {review.comment} ({review.rating} stars)
        </li>
      ))}
    </ul>

    {/* Add more course details as needed */}
  </div>
  );
};

export default CourseDetail;
